import { useEffect } from 'react';
import { ChatLeft } from 'react-bootstrap-icons';
import { useNavigate, useParams } from 'react-router-dom';

import { Button, Divider, List, Skeleton, Typography } from 'antd';

import CommentItem from '@/components/shared/CommentItem';
import EmptyState from '@/components/shared/EmptyState';
import { coursesApi, Params } from '@/services/course';
import styled, { StyledProp } from '@/styled';

const CommentsTabs = (props: StyledProp) => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const [fetchComments, { data, isFetching, isUninitialized }] = coursesApi.endpoints.getAllMyComments.useLazyQuery();

  useEffect(() => {
    const params = { page: 1 } as Params;

    fetchComments({ courseHash: hash, params });
  }, [fetchComments, hash, isUninitialized]);

  if (isFetching) {
    return <Skeleton avatar paragraph={{ rows: 2 }} />;
  }

  if (data?.total_rows === 0 || isUninitialized) {
    return <EmptyState icon={<ChatLeft />} title='Nenhum comentário encontrado' description='' />;
  }

  const fetchNewPage = () => {
    fetchComments({ courseHash: hash, params: { ...data?.page, page: data?.page.page + 1 } });
  };

  return (
    <div className={props.className}>
      <List
        loadMore={
          data?.total_pages > 1 && (
            <Button disabled={isFetching || data?.page?.page >= data?.total_pages} onClick={fetchNewPage}>
              Carregar mais comentários
            </Button>
          )
        }
        locale={{ emptyText: <EmptyState icon={<ChatLeft />} title='Nenhum comentário encontrado' description='' /> }}
        dataSource={data?.data}
        renderItem={comment => (
          <div>
            <Typography.Title level={4} ellipsis className='commentTitle'>
              {comment.lessonTitle}
            </Typography.Title>
            <Typography.Text>{comment.moduleTitle}</Typography.Text>
            <CommentItem key={comment.id} comment={comment as any}>
              <Typography.Text
                className='button'
                underline
                onClick={() => navigate(`/curso/${hash}/aula/${comment.lessonId}`)}
              >
                Ver Respostas
              </Typography.Text>
            </CommentItem>
            <Divider />
          </div>
        )}
      />
    </div>
  );
};
export default styled(CommentsTabs)`
  .ant-select {
    min-width: 150px;
  }

  .button {
    cursor: pointer;
  }

  .commentTitle {
    margin-bottom: ${({ theme }) => theme.space.pxToRem(8)};
  }

  .input {
    margin-bottom: ${({ theme }) => theme.space.pxToRem(48)};
  }

  .ant-list-header {
    border-block-end: 1px solid ${({ theme }) => theme.palette.alpha(theme.palette.gray[0], 0.12)};
  }

  .ant-divider {
    border-block-start: 1px solid rgba(255, 255, 255, 0.1);
  }

  button {
    height: 40px;
    width: 100%;
  }

  span.ant-typography {
    color: ${({ theme }) => theme.colorTextSecondary};
  }
`;
